import { UnifiedAlarmGroup } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useAlarmGroupDetails(
  alarmGroupId: string | undefined,
  onSuccess?: (data: UnifiedAlarmGroup) => void,
  disabled = false, // conditionally enable/disable the initial api request and polling interval
  refetchInterval?: number
) {
  const host = window.location.hostname;
  // TODO: update this and use env variables for the base url
  const baseUrl =
    host === 'localhost'
      ? `http://${host}:${window.location.port}`
      : `https://event-flow-${host}`;
  const url = `${baseUrl}/api/alarm_groups/${alarmGroupId}`;
  const request = new Request(url);

  return useAuthenticatedRequest<UnifiedAlarmGroup>(request, {
    queryKey: ['alarm_group_details', alarmGroupId],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    refetchInterval: !disabled && !!alarmGroupId ? refetchInterval : undefined,
    refetchIntervalInBackground: true,
    onSuccess,
    enabled: !disabled && !!alarmGroupId,
  });
}

export default useAlarmGroupDetails;
